import {
  GET_MAILBOX_SHOPIFY,
  GET_CUSTOMER_DETAILS_SHOPIFY,
  GET_CUSTOMER_ORDER_SHOPIFY,
  GET_SHOPIFY_SHOP_LIST,
  EDIT_SHOPIFY_SHOP,
  DELETE_SHOPIFY_SHOP,
  GET_SHOPIFY_PRODUCT_LIST,
  CREATE_DRAFT_ORDER,
  UPDATE_DRAFT_ORDER,
  DELETE_DRAFT_ORDER,
  DRAFT_TO_COMPLETE_ORDER,
  CREATE_DUPLICATE_ORDER,
  REFUND_SHOPIFY_ORDER,
  GET_LIVECHAT,
  GET_BIGCOMMERCE_STORE_CUSTOMER_DETAILS,
  GET_BIGCOMMERCE_CUSTOMER_ADDRESS,
  GET_BIGCOMMERCE_ORDER_LIST,
  GET_BIGCOMMERCE_PRODUCT_LIST,
  BIGCOMMERCE_CALCULATE_REFUND,
  GET_BIGCOMMERCE_SHOP_LIST,
  GET_MAILBOX_BIGCOMMERCE,
  GET_JIRA,
  GET_JIRA_ISSUES,
  JIRA_LINK_ISSUE_WITH_CONVERSATION,
  GET_JIRA_CONVERSATION_ISSUES,
  JIRA_UNLINK_ISSUE_WITH_CONVERSATION,
  GET_JIRA_PROJECT_ISSUES_TYPES,
  GET_JIRA_USERS_LIST,
  GET_GITHUB,
  STATE_GITHUB,
  GET_GITHUB_CONVERSATION_ISSUES,
  GET_GITHUB_REPOS,
  GET_GITHUB_LABELS,
  GET_GITHUB_MILESTONES,
  GET_GITHUB_COLLABORATORS,
  GET_GITHUB_ISSUES_FOR_REPO,
  GET_GITHUB_LINKED_ISSUE,
  GET_ASANA,
  GET_ASANA_WORKSPACES,
  GET_ASANA_ASSIGNEES,
  GET_ASANA_TAGS,
  GET_ASANA_PROJECTS,
  GET_ASANA_TASK_FOR_PROJECT,
  GET_ASANA_TASK_DETAILS,
  GET_LINKED_ASANA_TASKS,
  INSTALL_ASANA,
  INTEGRATE_ASANA,
  GET_CLICKUP,
  DELETE_CLICKUP,
  INSTALL_CLICKUP,
  GET_CLICKUP_WORKSPACES,
  GET_CLICKUP_SPACES,
  GET_CLICKUP_LIST_WITHIN_SPACE,
  GET_CLICKUP_FOLDERS_WITHIN_SPACE,
  GET_CLICKUP_TASKS_FROM_LIST,
  GET_CLICKUP_TAGS,
  GET_CLICKUP_LINKED_TASKS,
  GET_TRELLO,
  INSTALL_TRELLO,
  GET_TRELLO_LINKED_CARDS,
  GET_TRELLO_BOARDS,
  GET_TRELLO_LISTS,
  GET_TRELLO_CARDS,
  GET_TRELLO_LABELS,
  GET_TRELLO_MEMBERS,
  GET_MAGENTO,
  GET_MAGENTO_ORDERS,
  GET_LINKED_ORDERS,
  INSTALL_SLACK,
  GET_SLACK,
  GET_INTERCOM,
  DELETE_INTERCOM,
  INSTALL_INTERCOM,
  INSTALL_DRIFT,
  GET_DRIFT,
  GET_INTEGRATION_LIST,
  DELETE_DRIFT,
  DELETE_SLACK,
  DELETE_TRELLO,
  DELETE_ASANA,
  DELETE_LIVECHAT,
  INSTALL_LIVECHAT,
  GET_SHOPIFY_PAYMENT_TERMS,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_MAILBOX_SHOPIFY:
      return {
        ...state,
        shopifyMailBox: action.payload,
      }

    case GET_MAILBOX_BIGCOMMERCE:
      return {
        ...state,
        bigCommerceMailbox: action.payload,
      }

    case GET_CUSTOMER_DETAILS_SHOPIFY:
      return {
        ...state,
        customerDetailsShopify: action.payload,
      }

    case GET_CUSTOMER_ORDER_SHOPIFY:
      return {
        ...state,
        customerOrderShopify: action.payload,
      }

    case GET_SHOPIFY_SHOP_LIST:
      return {
        ...state,
        getShopifyShopList: action.payload,
      }

    case GET_BIGCOMMERCE_SHOP_LIST:
      return {
        ...state,
        getBigCommerceShopList: action.payload,
      }

    case EDIT_SHOPIFY_SHOP:
      return {
        ...state,
        editShopifyShop: action.payload,
      }

    case DELETE_SHOPIFY_SHOP:
      return {
        ...state,
        getShopifyShopList: state.getShopifyShopList.filter(shop => shop.id !== action.payload.id),
      }

    case GET_SHOPIFY_PRODUCT_LIST:
      return {
        ...state,
        shopifyProductList: action.payload || [],
      }

    case CREATE_DRAFT_ORDER:
    case UPDATE_DRAFT_ORDER:
    case DELETE_DRAFT_ORDER:
    case CREATE_DUPLICATE_ORDER:
      return {
        ...state,
        draftOrderData: action.payload,
      }

    case DRAFT_TO_COMPLETE_ORDER:
      return {
        ...state,
        draftOrderData: action.payload,
      }

    case 'CLEAR_DRAFT_TO_COMPLETE_ORDER':
      return {
        ...state,
        draftOrderData: {},
      }
    case GET_SHOPIFY_PAYMENT_TERMS:
      return {...state, shopifyPaymentTerms: action.payload}

    case REFUND_SHOPIFY_ORDER: {
      return {
        ...state,
        cancelOrRefundOrderStatus: action.status || action.error,
      }
    }

    case GET_BIGCOMMERCE_STORE_CUSTOMER_DETAILS: {
      return {
        ...state,
        bigCommerceCustomerDetails: action.payload,
      }
    }

    case GET_BIGCOMMERCE_CUSTOMER_ADDRESS:
      return {
        ...state,
        bigCommerceCustomerAddress: action.payload,
      }

    case GET_BIGCOMMERCE_ORDER_LIST:
      return {
        ...state,
        bigCommerceOrderList: action.payload,
      }

    case GET_BIGCOMMERCE_PRODUCT_LIST:
      return {
        ...state,
        bigCommerceProductList: action.payload,
      }

    case BIGCOMMERCE_CALCULATE_REFUND:
      return {
        ...state,
        bigCommerceCalculatedRefund: action.payload,
      }

    case 'CLEAR_BIGCOMMERCE_CALCULATE_REFUND':
      return {
        ...state,
        bigCommerceCalculatedRefund: null,
      }

    case GET_GITHUB: {
      return {
        ...state,
        githubData: action.payload,
      }
    }
    case STATE_GITHUB: {
      return {
        ...state,
        githubData: action.payload,
      }
    }
    case GET_GITHUB_REPOS: {
      return {
        ...state,
        githubRepos: action.payload,
      }
    }

    case GET_GITHUB_CONVERSATION_ISSUES:
      return {
        ...state,
        githubConversationIssues: action.payload,
      }

    case GET_GITHUB_LABELS:
      return {
        ...state,
        githubLabels: action.payload,
      }

    case GET_GITHUB_MILESTONES:
      return {
        ...state,
        githubMileStones: action.payload,
      }

    case GET_GITHUB_ISSUES_FOR_REPO:
      return {
        ...state,
        githubIssuesForRepo: action.payload,
      }

    case GET_GITHUB_LINKED_ISSUE:
      return {
        ...state,
        githubLinkedIssues: action.payload,
      }

    case GET_GITHUB_COLLABORATORS:
      return {
        ...state,
        githubCollaborators: action.payload,
      }

    case GET_ASANA: {
      return {
        ...state,
        asanaData: action.payload,
      }
    }
    case DELETE_ASANA: {
      return {
        ...state,
        asanaData: {},
      }
    }

    case INSTALL_ASANA: {
      return {
        ...state,
        asanaData: action.payload,
      }
    }
    case GET_ASANA_WORKSPACES: {
      return {
        ...state,
        asanaWorkspaces: action.payload,
      }
    }

    case GET_ASANA_ASSIGNEES: {
      return {
        ...state,
        asanaAssignees: action.payload,
      }
    }

    case GET_ASANA_TAGS: {
      return {
        ...state,
        asanaTags: action.payload,
      }
    }

    case GET_ASANA_PROJECTS:
      return {
        ...state,
        asanaProjects: action.payload,
      }

    case GET_ASANA_TASK_FOR_PROJECT:
      return {
        ...state,
        asanaProjectTasks: action.payload,
      }

    case GET_ASANA_TASK_DETAILS:
      return {
        ...state,
        asanaTaskDetails: action.payload,
      }

    case GET_LINKED_ASANA_TASKS:
      return {
        ...state,
        asanaLinkedTasks: action.payload,
      }

    case INTEGRATE_ASANA:
      return {
        ...state,
        asanaRedirectLink: action.payload,
      }

    case GET_CLICKUP: {
      return {
        ...state,
        clickupData: action.payload,
      }
    }
    case DELETE_CLICKUP: {
      return {
        ...state,
        clickupData: {},
      }
    }
    case INSTALL_CLICKUP: {
      return {
        ...state,
        clickupData: action.payload,
      }
    }
    case GET_CLICKUP_WORKSPACES:
      return {
        ...state,
        clickupWorkspaces: action.payload,
      }

    case GET_CLICKUP_SPACES:
      return {
        ...state,
        clickupSpaces: action.payload,
      }

    case GET_CLICKUP_LIST_WITHIN_SPACE:
      return {
        ...state,
        clickupListWithinSpace: action.payload,
      }

    case GET_CLICKUP_FOLDERS_WITHIN_SPACE:
      return {
        ...state,
        clickupFolderWithinSpace: action.payload,
      }

    case GET_CLICKUP_TASKS_FROM_LIST:
      return {
        ...state,
        clickupTasksFromList: action.payload,
      }

    case GET_CLICKUP_TAGS:
      return {
        ...state,
        clickupTags: action.payload,
      }

    case GET_CLICKUP_LINKED_TASKS:
      return {
        ...state,
        clickupConversationTasks: action.payload,
      }

    case GET_TRELLO: {
      return {
        ...state,
        trelloData: action.payload,
      }
    }
    case DELETE_TRELLO: {
      return {
        ...state,
        trelloData: {},
      }
    }
    case INSTALL_TRELLO: {
      return {
        ...state,
        trelloData: action.payload,
      }
    }

    case GET_TRELLO_LINKED_CARDS:
      return {
        ...state,
        trelloConversationCards: action.payload,
      }

    case GET_TRELLO_BOARDS: {
      return {...state, trelloBoards: action.payload}
    }

    case GET_TRELLO_LABELS: {
      return {...state, trelloLabels: action.payload}
    }

    case GET_TRELLO_CARDS: {
      return {...state, trelloCards: action.payload}
    }

    case GET_TRELLO_LISTS: {
      return {...state, trelloLists: action.payload}
    }

    case GET_TRELLO_MEMBERS: {
      return {...state, trelloMembers: action.payload}
    }

    case GET_JIRA: {
      return {
        ...state,
        jiraData: action.payload,
      }
    }

    case 'CLEAR_DELETE_JIRA':
      return {
        ...state,
        jiraData: null,
      }

    case GET_JIRA_ISSUES:
      return {
        ...state,
        jiraIssues: action.payload,
      }

    case JIRA_LINK_ISSUE_WITH_CONVERSATION: {
      const issueId = action.payload?.issueId
      const jiraConversationIssue = state.jiraConversationIssues?.issues ? state.jiraConversationIssues.issues : []
      return {
        ...state,
        jiraConversationIssues: issueId
          ? {
              issues: [...jiraConversationIssue, state.jiraIssues.issues.find(issue => issue.id === issueId)],
            }
          : state.jiraConversationIssues,
      }
    }

    case JIRA_UNLINK_ISSUE_WITH_CONVERSATION: {
      const issueId = action.payload?.id
      const jiraConversationIssue = state.jiraConversationIssues?.issues
        ? state.jiraConversationIssues.issues.filter(issue => issue.id !== issueId)
        : []

      return {
        ...state,
        jiraConversationIssues: issueId
          ? {
              issues: [...jiraConversationIssue],
            }
          : state.jiraConversationIssues,
      }
    }

    case GET_JIRA_CONVERSATION_ISSUES:
      return {
        ...state,
        jiraConversationIssues: action.payload,
      }

    case GET_JIRA_PROJECT_ISSUES_TYPES:
      return {
        ...state,
        jiraProjectIssueTypes: action.payload,
      }

    case GET_JIRA_USERS_LIST:
      return {
        ...state,
        jiraUsersList: action.payload,
      }

    case GET_MAGENTO:
      return {
        ...state,
        magentoList: action.payload,
      }

    case GET_MAGENTO_ORDERS:
      return {
        ...state,
        magentoOrders: action.payload,
      }
    case GET_LINKED_ORDERS:
      return {
        ...state,
        linkedOrders: action.payload,
      }
    case INSTALL_SLACK:
      return {
        ...state,
        slackData: action.payload,
      }
    case GET_SLACK:
      return {
        ...state,
        slackData: action.payload,
      }
    case DELETE_SLACK:
      return {
        ...state,
        slackData: {},
      }
    case GET_INTERCOM:
      return {
        ...state,
        intercomData: action.payload,
      }
    case DELETE_INTERCOM:
      return {
        ...state,
        intercomData: {},
      }
    case INSTALL_INTERCOM:
      return {
        ...state,
        intercomData: action.payload,
      }
    case GET_LIVECHAT:
      return {
        ...state,
        liveChatData: action.payload,
      }
    case DELETE_LIVECHAT:
      return {
        ...state,
        liveChatData: {},
      }
    case INSTALL_LIVECHAT:
      return {
        ...state,
        liveChatData: action.payload,
      }

    case GET_DRIFT:
      return {
        ...state,
        driftData: action.payload,
      }
    case DELETE_DRIFT:
      return {
        ...state,
        driftData: {},
      }
    case INSTALL_DRIFT:
      return {
        ...state,
        driftData: action.payload,
      }

    case GET_INTEGRATION_LIST:
      return {
        ...state,
        integrationList: action.payload,
      }

    default:
      return state
  }
}
